(function () {

  function injectEyebrows() {
    var cards = document.querySelectorAll('.kl_reviews__carousel__review');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.kl-product-eyebrow')) continue;
      var link = card.closest('a.kl_reviews__carousel__link');
      if (!link) continue;
      var parts = link.href.split('/products/');
      if (parts.length < 2) continue;
      var slug = parts[1].split('?')[0];
      var productName = slug.split('-').map(function(w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
      }).join(' ');
      var header = card.querySelector('.kl_reviews__carousel__content__header');
      if (!header) continue;
      var eyebrow = document.createElement('div');
      eyebrow.className = 'kl-product-eyebrow';
      eyebrow.textContent = productName;
      header.parentNode.insertBefore(eyebrow, header);
    }
  }

function injectScrollControls() {
  var wrapper = document.getElementById('klaviyo-reviews-carousel-wrapper');
  if (!wrapper) return;
  if (wrapper.querySelector('.kl-scroll-controls')) return;

  var heading = wrapper.querySelector('.kl_reviews__carousel__header');
  if (!heading) return;

  var swiper = wrapper.querySelector('.swiper-wrapper');
  if (!swiper) return;

  // Tag swiper as the drag track
  swiper.setAttribute('data-carousel-track', '');

  function clickKlaviyo(selector) {
    var btn = document.querySelector(selector);
    if (btn) btn.click();
  }

  // Build header row
  var headerRow = document.createElement('div');
  headerRow.className = 'kl-header-row';
  headerRow.innerHTML = [
    '<div class="kl-scroll-controls">',
      '<button type="button" class="scroll-btn" aria-label="Previous reviews">',
        '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="10,3 5,8 10,13"/></svg>',
      '</button>',
      '<button type="button" class="scroll-btn" aria-label="Next reviews">',
        '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6,3 11,8 6,13"/></svg>',
      '</button>',
      '<a href="/collections/build-a-box" class="btn btn--pill">Build Your Box →</a>',
    '</div>'
  ].join('');

  wrapper.insertBefore(headerRow, heading.nextSibling);
  headerRow.insertBefore(heading, headerRow.firstChild);

  headerRow.querySelectorAll('button')[0].addEventListener('click', function() {
    clickKlaviyo('.kl_reviews__carousel__prev_button');
  });
  headerRow.querySelectorAll('button')[1].addEventListener('click', function() {
    clickKlaviyo('.kl_reviews__carousel__next_button');
  });
  

  // Manually attach drag scroll to the Swiper element
  var DRAG_THRESHOLD = 6;
  var dragging = false;
  var moved = false;
  var startX = 0;
  var startScroll = 0;

  swiper.addEventListener('pointerdown', function(e) {
    if (e.pointerType === 'touch') return;
    if (e.button !== 0) return;
    dragging = true;
    moved = false;
    startX = e.clientX;
    startScroll = swiper.scrollLeft;

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < DRAG_THRESHOLD) return;
      moved = true;
      swiper.scrollLeft = startScroll - dx;
    }

    function onUp() {
      dragging = false;
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      if (moved) {
        swiper.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
        }, { capture: true, once: true });
      }
    }

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
  });

  swiper.addEventListener('dragstart', function(e) { e.preventDefault(); });
  swiper.style.cursor = 'grab';
}




  var eyebrowsDone = false;
  var controlsDone = false;
  var attempts = 0;

  var interval = setInterval(function() {
    attempts++;

    if (!eyebrowsDone && document.querySelectorAll('.kl_reviews__carousel__review').length > 0) {
      injectEyebrows();
      eyebrowsDone = true;
    }

    if (!controlsDone && document.getElementById('klaviyo-reviews-carousel-wrapper')) {
      injectScrollControls();
      controlsDone = true;
    }

    if ((eyebrowsDone && controlsDone) || attempts >= 50) {
      clearInterval(interval);
    }
  }, 200);

})();
